import React from "react";
import RegistrarAsistencia from "../../components/3.1 asistencia/formulario";
import ListaAsistencia from "../../components/3.1 asistencia/asistencia";

const AsistenciaPage = () => {
  return (
    <>
      <RegistrarAsistencia />
      <ListaAsistencia />
    </>
  );
};

export default AsistenciaPage;
